const en = {
  metaLogin: "Sign in",
  metaRegister: "Create your account",
  metaForgot: "Reset your password",
  metaReset: "Choose a new password",
  metaVerify: "Verify your email",
  loginTitle: "Welcome back",
  loginSubtitle: "Sign in to manage your stores.",
  passwordChanged: "Your password was changed. Sign in with your new password.",
  newToStorelancer: "New to Storelancer?",
  createAnAccount: "Create an account",
  registerTitle: "Create your account",
  registerSubtitle: "Start on the free Starter plan. No card required.",
  haveAccount: "Already have an account?",
  signIn: "Sign in",
  signingIn: "Signing in…",
  forgotTitle: "Reset your password",
  forgotSubtitle: "Enter your account email and we’ll send you a reset link.",
  backToSignIn: "Back to sign in",
  resetTitle: "Choose a new password",
  resetLinkIncomplete: "This reset link is incomplete.",
  requestNewOne: "Request a new one",
  verifyTitle: "Email verification",
  verifyLinkIncomplete: "This verification link is incomplete.",
  verifyRequestNew: "You can request a new link from your account settings.",
  verifySuccess: "Your email address is verified.",
  goToDashboard: "Go to dashboard",
  fieldEmail: "Email",
  fieldPassword: "Password",
  fieldName: "Your name",
  fieldNewPassword: "New password",
  fieldConfirmPassword: "Confirm password",
  forgotLink: "Forgot your password?",
  passwordHint: "At least 10 characters with a letter and a number.",
  termsAgree: "I agree to the {terms} and {privacy}",
  termsLink: "terms of service",
  privacyLink: "privacy policy",
  createAccount: "Create account",
  creatingAccount: "Creating account…",
  sendResetLink: "Send reset link",
  sending: "Sending…",
  setNewPassword: "Set new password",
  acceptTerms: "Please accept the terms of service.",
  required: "Required",
  resetSent: "If an account exists for that email, we’ve sent a reset link. It expires in 1 hour.",
  passwordsDontMatch: "Passwords don’t match.",
};

export default en;
